import { useState, useEffect, useRef } from "react";
import testimonials from "../../assets/data/testimonialsData";
import {
  Section,
  Title,
  CarouselWrapper,
  Track,
  Card,
  CardContent,
  Feedback,
  Cite,
  Dots,
  Dot,
} from "./Testimonials.styles";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const [isInView, setIsInView] = useState(false);
  const wrapperRef = useRef(null);
  const sectionRef = useRef(null);

  const totalCards = testimonials.length;
  const fullList = [...testimonials, ...testimonials.slice(0, visibleCount)];

  useEffect(() => {
    const updateWidth = () => {
      if (wrapperRef.current) {
        const fullWidth = wrapperRef.current.offsetWidth;
        const count = fullWidth < 768 ? 1 : 3; // 1 card on mobile
        const gapAdjustment = fullWidth < 768 ? 10 : 0;
        setVisibleCount(count);
        setCardWidth(fullWidth / count - gapAdjustment);
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.3,
      },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isInView) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalCards);
    }, 6000);

    return () => clearInterval(interval);
  }, [totalCards, isInView]);

  const translateX =
    visibleCount === 1
      ? currentIndex * cardWidth // For mobile, only one card is visible
      : currentIndex * cardWidth;

  const trackWidth = fullList.length * cardWidth;

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <Section id="testimonials" ref={sectionRef}>
      <Title>Testimonials</Title>
      <CarouselWrapper ref={wrapperRef}>
        <Track
          $translate={translateX}
          $trackWidth={trackWidth}
          $transition={true}
        >
          {fullList.map((t, index) => {
            const centerIndex = currentIndex + Math.floor(visibleCount / 2);
            const position = index - centerIndex;

            return (
              <Card
                key={index}
                $width={cardWidth}
                $position={position}
                onClick={() => setCurrentIndex(index - 1)}
              >
                <CardContent $isCenter={position === 0}>
                  <Feedback>{t.feedback}</Feedback>
                  <Cite>
                    {t.name}
                    <br />
                    {t.title}
                  </Cite>
                </CardContent>
              </Card>
            );
          })}
        </Track>

        <Dots>
          {Array.from({ length: totalCards }).map((_, i) => (
            <Dot
              key={i}
              $active={i === currentIndex % totalCards ? 1 : 0}
              onClick={() => handleDotClick(i)}
            />
          ))}
        </Dots>
      </CarouselWrapper>
    </Section>
  );
};

export default Testimonials;
